var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardAme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "inherit",
    viewBox: "0 0 20 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.462 3.111a.387.387 0 00-.385.389v.778c0 .215.172.389.385.389H5a.387.387 0 00.385-.39V3.5A.387.387 0 005 3.111H3.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.333C0 1.045 1.033 0 2.308 0h15.384C18.967 0 20 1.045 20 2.333v9.334C20 12.955 18.967 14 17.692 14H2.308C1.033 14 0 12.955 0 11.667V2.333zm1.538 0c0-.43.345-.777.77-.777h15.384c.425 0 .77.348.77.777v2.638l-1.396-1.426a1.426 1.426 0 00-1.017-.434H9.336c-.385 0-.741.157-1.017.434L6.626 5.274a1.684 1.684 0 00-.472 1.183c0 .404.145.793.385 1.07l4.794 4.917H2.308a.774.774 0 01-.77-.777V2.333zm12.515 10.111h3.64a.773.773 0 00.768-.777V7.933c-.497.511-1.666 1.706-4.408 4.511zM13.2 5.401l1.053-1.077H11.13L12.184 5.4a.68.68 0 00.508.217.68.68 0 00.509-.217zm-.32 6.519l5.086-5.202a.372.372 0 00.08-.269.445.445 0 00-.11-.3L16.23 4.407a.26.26 0 00-.189-.082c-.08 0-.138.022-.181.067l-1.824 1.87a1.874 1.874 0 01-1.344.57c-.508 0-.98-.202-1.344-.562L9.525 4.4a.21.21 0 00-.16-.068h-.022a.293.293 0 00-.189.082l-1.692 1.73a.44.44 0 00-.022.606s5.034 5.149 5.063 5.171a.26.26 0 00.19.082.234.234 0 00.188-.082z"
  })));
}

export default SvgCardAme;